import React, { useContext } from 'react'
import PropType from 'prop-types'

import Font from '@cred/react-font'

import withReduxProvider from 'components/hocs/withReduxProvider'
import WidgetContext from 'components/widget-context'
import { AdvertiserDisclosure } from 'components/advertiser-disclosure'

import styles from '../copy-only/styles.module.scss'

const Interactive = ({ href, theme, title, body, ctaText, Form, queryString, metaQuery }) => {
  const widgetContext = useContext(WidgetContext)
  const formProps = { href, theme, ctaText, widgetContext, queryString, metaQuery }
  const isFoxTheme = theme === 'fox'

  return (
    <div className={styles.container}>
      {isFoxTheme && <AdvertiserDisclosure />}
      <div className={`${styles.widget} ${styles.interactive}`}>
        <div className={`${styles.copy} ${styles.interactive}`}>
          <Font
            type="heading"
            weight="bold"
            className={`${styles.title} ${styles.interactive} mb-8`}
          >
            {title}
          </Font>
          <Font className={`${styles.body} mb-16 mb-sm-0`}>{body}</Font>
        </div>
        <div className={`${styles.cta} ${styles.interactive}`}>
          <Form {...formProps} />
        </div>
      </div>
    </div>
  )
}

Interactive.propTypes = {
  href: PropType.string.isRequired,
  title: PropType.string.isRequired,
  body: PropType.string.isRequired,
  ctaText: PropType.string.isRequired,
  theme: PropType.string.isRequired,
  Form: PropType.func,
  queryString: PropType.string,
  metaQuery: PropType.string,
}

export { Interactive }

export default withReduxProvider(Interactive)
